module.exports = __webpack_public_path__ + "static/img/crypto.47e71167.png";